


































import { Vue, Component, Prop } from 'vue-property-decorator';
import CourseStatusCountItemContainer from './CourseStatusCountItemContainter.vue';

@Component({
  components: {
    CourseStatusCountItemContainer
  }
})
export default class CourseStatusCountItem extends Vue {
  @Prop({ type: Number, default: 0 }) public readonly countValue!: number;
  @Prop(String) public readonly displayName!: string;
  @Prop(String) public readonly tooltipDescription!: string;
  @Prop({ type: Boolean, default: false }) public readonly isLastItem!: boolean;
}
